import {Component, Inject, NgZone, OnInit} from '@angular/core';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';

import { ZoomMtg } from '@zoom/meetingsdk';
import {HttpClient} from '@angular/common/http';
import {DOCUMENT} from '@angular/common';

// ZoomMtg.preLoadWasm();
// ZoomMtg.prepareWebSDK();

@Component({
    selector: 'test-page',
    templateUrl: './test.page.html',
    styleUrls: ['./test.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]
})

export class TestPage implements OnInit {

    authEndpoint = ''
    sdkKey = ''
    meetingNumber = '123456789'
    passWord = ''
    role = 0
    userName = 'Angular'
    userEmail = ''
    registrantToken = ''
    zakToken = ''
    leaveUrl = 'http://localhost:4200'

    constructor(
        public httpClient: HttpClient, @Inject(DOCUMENT) document, private ngZone: NgZone
    ) {}

    ngOnInit() {
    }

    getSignature() {
        this.httpClient.post(this.authEndpoint, {
            meetingNumber: this.meetingNumber,
            role: this.role
        }).subscribe((data: any) => {
            if(data.signature) {
                console.log(data.signature)
                this.startMeeting(data.signature)
            } else {
                console.log(data)
            }
        })
    }

    startMeeting(signature) {

        document.getElementById('zmmtg-root').style.display = 'block'

        this.ngZone.runOutsideAngular(() => {
            ZoomMtg.init({
                leaveUrl: this.leaveUrl,
                patchJsMedia: true,
                leaveOnPageUnload: true,
                success: (success) => {
                    console.log(success)
                    ZoomMtg.join({
                        signature: signature,
                        sdkKey: this.sdkKey,
                        meetingNumber: this.meetingNumber,
                        passWord: this.passWord,
                        userName: this.userName,
                        userEmail: this.userEmail,
                        tk: this.registrantToken,
                        zak: this.zakToken,
                        success: (success) => {
                            console.log(success)
                        },
                        error: (error) => {
                            console.log(error)
                        }
                    })
                },
                error: (error) => {
                    console.log(error)
                }
            })
        })
    }

}
